import { useState } from 'react';
import { useLang } from '@/i18n/LanguageContext';

// Question/answer dictionary keys, in display order. The "install" entry is new
// (added to clarify the product is a Chrome extension) and sits near the top.
const FAQ_KEYS: { q: string; a: string }[] = [
  { q: 'faq.q.install', a: 'faq.a.install' },
  { q: 'faq.q.crm_leave', a: 'faq.a.crm_leave' },
  { q: 'faq.q.send', a: 'faq.a.send' },
  { q: 'faq.q.access', a: 'faq.a.access' },
  { q: 'faq.q.crm_which', a: 'faq.a.crm_which' },
  { q: 'faq.q.store', a: 'faq.a.store' },
  { q: 'faq.q.vs', a: 'faq.a.vs' },
  { q: 'faq.q.cost', a: 'faq.a.cost' },
  { q: 'faq.q.who', a: 'faq.a.who' },
];

interface FAQProps {
  onTalkToUs: () => void;
}

export default function FAQ({ onTalkToUs }: FAQProps) {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="section" id="faq" data-screen-label="FAQ">
      <div className="container">
        <div className="faq-wrap">
          <div className="section-head reveal" style={{ maxWidth: 'none', position: 'sticky', top: 96 }}>
            <span className="eyebrow">{t('faq.eyebrow')}</span>
            <h2 className="h-section">
              {t('faq.h2.line1')}
              <br />
              {t('faq.h2.line2')}
            </h2>
            <p className="lead" style={{ fontSize: 16 }}>
              {t('faq.talk.pre')}
              <a
                href="#cta"
                className="linkout"
                style={{ fontSize: 16 }}
                onClick={(e) => {
                  e.preventDefault();
                  onTalkToUs();
                }}
              >
                {t('faq.talk.link')}
              </a>
            </p>
          </div>

          <div className="faq-list reveal" data-d="1">
            {FAQ_KEYS.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.q}>
                  <button className="faq-q" onClick={() => setOpenIdx(isOpen ? -1 : i)}>
                    {t(item.q)}
                    <span className="pm" />
                  </button>
                  <div className="faq-a" style={{ maxHeight: isOpen ? 320 : 0 }}>
                    <div className="faq-a-inner">{t(item.a)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
